import Image from "next/image";

export const NoIssueBox = ({ message }: { message: string }) => {
  return (
    <div className="flex items-center gap-1 rounded-xl border-3 border-white bg-green-100 px-[10px] py-[10px] xs:gap-2 xs:px-[15px] xs:py-[15px] lg:gap-3 lg:px-[15px] lg:py-[15px] xl:gap-4 xl:px-[20px] xl:py-[20px]">
      <Image
        src="/icons/greenTick.svg"
        alt="No Spelling Mistakes"
        width={30}
        height={30}
        className="h-4 w-4 xs:h-5 xs:w-5 lg:h-4 lg:w-4 xl:h-5 xl:w-5 2xl:h-6 2xl:w-6"
      />
      <span className="text-[10px] font-medium text-green-600 xs:text-xs sm:text-sm md:text-base lg:text-sm xl:text-base lg:font-semibold">
        {message}
      </span>
    </div>
  );
};
